import { app } from '../app.module'
app.controller('GroupCtrl', ($scope, $rootScope, $state, Restangular, $mdDialog) => {
  // URLの直接入力で、adminでないグループのユーザーが遷移してきた場合は、
  // 投稿一覧にリダイレクトさせる
  if ($rootScope.isAdmin !== true) {
    $state.go('post')
  }

  // 画面遷移時に、初期化処理を行う
  initProcess()

  // 画面遷移
  $scope.stateGo = function (stateName) {
    $state.go(stateName)
  }

  // グループの新規登録、編集、削除が完了した場合は、データをリロードする
  $rootScope.$on('changeGroupData', () => {
    initProcess()
  })

  // グループ編集モーダルを呼び出す
  $scope.showEditGroupModal = function (groupId: number) {
    const template = `<edit-group-modal group-id=${groupId}></edit-group-modal>`
    $mdDialog.show({
      template: template,
      clickOutsideToClose: true,
    })
  }

  /**
   * キーワードの変更イベント
   * @param {string} keyword キーワード
   */
  $scope.changeKeywordFilter = (keyword: string) => {
    if ($scope.keyword === keyword) {
      return
    }
    $scope.keyword = keyword
    // フィルターを変更する
    $scope.sortGroups = filterGroups($scope.groups, $scope.keyword)
  }

  /**
   * DBから取得したデータを表示用に変換する
   * @param  {object} groupData グループ情報
   * @return {object} 変換したグループ情報
   */
  function convertGroupData(groupData) {
    if (groupData.plan === 'pro') {
      groupData.plan = 'プロ'
    }
    if (groupData.plan === 'lite') {
      groupData.plan = 'ライト'
    }
    if (groupData.status === 0) {
      groupData.status = 'デモ'
    }
    if (groupData.status === 1) {
      groupData.status = '契約中'
    }
    if (groupData.status === 2) {
      groupData.status = '社内利用'
    }

    return groupData
  }

  /**
   * グループデータを取得し、スコープにセットする
   */
  function initProcess() {
    $scope.isLoading = true
    $scope.selected = []
    $scope.groups = []
    $scope.sortGroups = []
    $scope.keyword = null

    // 画面遷移時にグループデータを取得する
    Restangular.all('group/groups')
      .getList()
      .then((response) => {
        if (response[0].data !== null) {
          // DBから取得したグループ情報を、表示用に変換する
          $scope.groups = response[0].data.map(convertGroupData)
          $scope.sortGroups = $scope.groups
        }
        $scope.isLoading = false
      })
  }

  /**
   * グループをフィルタリングする
   * @param {array} groups グループデータ
   * @param {string} keyword 検索キーワード
   * @return {array} フィルタリングされたグループ
   */
  function filterGroups(groups, keyword: string) {
    let filterdGroups = groups

    // キーワードが選択されている場合は、グループ名とメモをキーワードでフィルタリングする
    if (keyword !== null && keyword !== undefined) {
      filterdGroups = filterdGroups.filter((group) => {
        if (group.name.indexOf(keyword) !== -1) {
          return true
        }

        if (group.memo !== null && group.memo.indexOf(keyword) !== -1) {
          return true
        }
      })
    }

    return filterdGroups
  }
})
